import { DateTimeTemplate } from './DateTimeTemplate';
import { StatusTemplate } from './StatusTemplate';
import { NotesTemplate } from './NotesTemplate';
import { CallerTemplate } from './CallerTemplate';

interface CallLogEntry {
  callDate: string;
  callBy: string;
  callTo: string;
  isCallAnswered: boolean;
  notes: string;
}

// Template functions for grid columns
export const dateTimeTemplate = (props: CallLogEntry) => (
  <DateTimeTemplate dateString={props.callDate} />
);

export const statusTemplate = (props: CallLogEntry) => (
  <StatusTemplate isAnswered={props.isCallAnswered} />
);

export const notesTemplate = (props: CallLogEntry) => (
  <NotesTemplate notes={props.notes} />
);

export const callerTemplate = (props: CallLogEntry) => (
  <CallerTemplate callBy={props.callBy} callTo={props.callTo} />
);
